import mr from './ascending.js';
function yr(series) {
  return mr(series).reverse();
}
export { yr as default };
//# sourceMappingURL=descending.js.map
